// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {RouteReportBase, RouteReportPayload} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchRouteReport(
  payload: RouteReportPayload
): Promise<APIResponse<RouteReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.routeReport, payload)
  return response.data
}
